import PropTypes from 'prop-types';
import React from 'react';
import { tacticMap } from '../../../../../../../classes/tactics/tacticKeys';
import { colors } from '../../../../../../../colorVars';
import { Body3 } from '../../../../../../atomic/text/Text';
import { timeUnitMap } from '../../../../../charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setupFilters/FTFCBoxes';
import { translateUppercaseSetups } from '../../utils/translateUppercaseSetups';

export const Setup = ({ alert }) => {
  const setup = alert.setup;

  const timeUnit = tacticMap[setup]?.determineTimeUnit(
    alert.setupDetails[setup]
  );
  const timeUnitAbbreviation = timeUnitMap[timeUnit] ?? null;
  const candleDuration = tacticMap[setup]?.determineCandleDuration(
    alert.setupDetails[setup]
  );
  return (
    <td>
      <Body3 color={colors.lightGrey} fontWeight={500}>
        {`${translateUppercaseSetups(setup)}${
          timeUnit && candleDuration
            ? '-' + candleDuration + timeUnitAbbreviation
            : ''
        }`}
      </Body3>
    </td>
  );
};

Setup.propTypes = {
  alert: PropTypes.shape({
    setup: PropTypes.any,
    setupDetails: PropTypes.any,
  }),
};
